<template>
	<div style="min-height: 600px;">
		<b-loading :is-full-page="false" :active.sync="loading" :can-cancel="false">
			<b-icon
				icon="sync-alt"
				custom-class="fa-spin">
			</b-icon>
			<p>Please wait while we find the account...</p>
		</b-loading>

		<div class="columns" v-if="!loading">
			<div class="column" v-if="(files.length > 0 && account.status.state === 'uploading') || files.length === 0"
			     :class="{'is-8': files.length > 0}">
				<template v-if="files.length > 0 && account.status.state === 'uploading'">
					<template v-if="userRole('upload_only')">
						<h4 class="title is-4">Upload Files</h4>
						<p>Upload your account files in the box below.</p>
					</template>
					<template v-else>
						<h4 class="title is-4">Confirm Uploaded Files</h4>
						<p>Please review the files below and add additional documents, or remove unwanted files using the Action key. By clicking the Request Account Setup button, Griptiller will take you to a confirmation page.</p>
					</template>
				</template>
				<template v-if="files.length === 0">
					<h4 class="title is-4">Upload Files</h4>
					<p>Please upload your Property list (SOV, COPE) and your engineering documents here.</p>
				</template>
			</div>
			<div class="column">
				<div class="has-text-right m-b-20">
					<template v-if="files.length > 0 && account.status.state === 'uploading'">
						<button
							v-bind:class="{ 'is-loading' : reviewRequestLoading }"
							v-if="userCan('update_accounts', 'accounts')"
							class="button is-medium is-primary"
							@click="requestSetup">
							Request Account Setup
						</button>
					</template>
					<template v-if="account.status.state === 'processing'">
						<b-message type="is-success">
							<b-button v-if="files.length > 0"
							          tag="router-link"
							          class="pull-right m-t-10"
							          type="is-primary"
							          to="/"
							          label="Return to Dashboard" />
							<h5 class="title is-5 m-b-15"><strong>Griptiller is organizing your account!</strong>
								<b-icon icon="cog" size="is-small" class="fa-spin pull-left" style="margin: 4px 10px 0 0 !important;" />
							</h5>
							<p class="m-b-0">Griptiller will notify you when account organization is complete.</p>
						</b-message>
					</template>
				</div>
			</div>
		</div>
		<div class="m-b-20">
			<uppy :account-id="account.id" :data="dropzoneData" v-on:upload-success="getAccountFiles" />
		</div>
		<div class="simple-account-files-wrapper" v-if="files.length && !loading">
			<account-files
				:filters="filesFilter"
				:show-vanity-by-default="account.show_vanity_by_default"
				:show-upload-button="false"
				:show-file-details="false"
				:show-file-actions="false"
				:show-disclosed-documents-download="false"
				:show-properties="false" />
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { ACCOUNT_FILES_GET } from '@/store/actions/accounts'
import { FORM_UPDATE } from '@/store/actions/form'
import AccountFiles from '@/components/Account/Tabs/AccountFiles'
import Uppy from '../Elements/Uppy.vue'

export default {
  data () {
    return {
      loading: false,
      reviewRequestLoading: false,
      files: [],
      filesFilter: { filter__property_id: this.id }
    }
  },
  props: {
    account: {
      type: Object
    }
  },
  components: {
    Uppy,
    AccountFiles
  },
  created () {
    this.loading = true
    this.getAccountFiles()
  },
  computed: {
    dropzoneData () {
      return {
        'account_id': this.account.id
      }
    },
    ...mapGetters({
      userCan: 'userCan',
      userRole: 'userRole'
    })
  },
  methods: {
    getAccountFiles () {
      this.$store.dispatch(ACCOUNT_FILES_GET, {
        'account_id': this.account.id
      }).then(response => {
        this.files = response.data
      }).catch(err => {
        console.error(err)
      }).finally(() => {
        this.loading = false
      })
    },
    requestSetup () {
      this.$buefy.dialog.confirm({
        title: 'Request Account Setup',
        message: 'By clicking the Request Setup button, Griptiller will organize your account, and then notify you when your account is ready to use.',
        confirmText: 'Request Setup',
        type: 'is-primary',
        hasIcon: false,
        onConfirm: () => {
          this.reviewRequestLoading = true

          const data = {
            id: this.account.id,
            model: 'accounts',
            fields: {
              status_state: 'processing'
            }
          }

          this.$store.dispatch(FORM_UPDATE, data).then(response => {
            this.$awn.success('A review of your files has been requested.')
            this.$emit('managed-status-changed', 'processing')
          }).catch(err => {
            console.error(err)
          }).finally(() => {
            this.reviewRequestLoading = false
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Account/SimpleAccountUploader.vue